import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';

@observer
class TextInputClass extends Component {
  @observable passwordVisible = false;

  render() {
    const {
      label,
      value = '',
      readOnly,
      onChange,
      placeholder,
      type,
      inputProps,
      small,
    } = this.props;

    const isTypePassword = type === 'password';

    return (
      <div className='formInput' style={isTypePassword ? { position: 'relative' } : {}}>
        {label && (<label>{label}</label>)}
        <input
          type={isTypePassword ? this.passwordVisible ? 'text' : 'password' : (type || 'text')}
          value={value || ''}
          readOnly={readOnly}
          onChange={onChange}
          placeholder={placeholder}
          {...inputProps}
          style={Object.assign({}, (small ? { width: '88px', minWidth: '88px' } : {}))}
        />
        {isTypePassword ? <span className='action'>
          <i className={`fa fa-eye${this.passwordVisible ? '' : '-slash'}`} onClick={() => this.passwordVisible = !this.passwordVisible} />
        </span> : null}
      </div>
    );
  }
}

export default TextInputClass;


// WEBPACK FOOTER //
// ./src/components/Form/TextInput.js